import { BigAppleOptions } from '../game-engine/maps-utils/big-apple';
import { DegenRaceway } from '../game-engine/maps-utils/degen-raceway';
import { MapsTemp } from '../game-engine/maps-utils/map-functions-temp';
import { MiamiBeach } from '../game-engine/maps-utils/miami-beach';
import { StackPlazaOptions } from '../game-engine/maps-utils/stack-platza';

type IMapOptions = Record<MapsTemp, any>;

export interface IMapLobbiesImg {
  imgUrl: string;
}

export const MapOptions: IMapOptions = {
  bigApple: BigAppleOptions,
  degenRaceway: DegenRaceway,
  miamiBeach: MiamiBeach,
  stackPlaza: StackPlazaOptions,
};

export const MapLobbiesImg: Record<string, any> = {
  bigApple: 'https://stacksdegens.com/assets/images/game-play/1.jpg',
  miamiBeach: 'https://stacksdegens.com/assets/images/game-play/2.jpg',
  stackPlaza: 'https://stacksdegens.com/assets/images/game-play/3.jpg',
  degenRaceway: 'https://stacksdegens.com/assets/images/game-play/4.jpg',
  'big-apple': 'https://stacksdegens.com/assets/images/game-play/1.jpg',
  'miami-beach': 'https://stacksdegens.com/assets/images/game-play/2.jpg',
  'stack-plaza': 'https://stacksdegens.com/assets/images/game-play/3.jpg',
  'degen-raceway': 'https://stacksdegens.com/assets/images/game-play/4.jpg',
};
